import React, { ReactElement } from "react";

import { Alert, AlertDescription, Link } from "@zapier/design-system";

import { OverdueInvoice } from "../../../types";

interface Props {
  failureReason:
    | "authentication_required"
    | "card_error"
    | "network_error"
    | null
    | undefined;
}

const messages: Record<
  NonNullable<OverdueInvoice["failureReason"]> | "fallback",
  string | ReactElement
> = {
  authentication_required:
    "The card declined as your bank requires an additional security step. Try your payment again to complete the process.",
  card_error:
    "The payment was not processed as the card was declined. Try a different payment method or contact your card issuer for help.",
  network_error: (
    <>
      The payment was not processed due to a technical problem. Try again now or
      <Link href="https://zapier.com/app/get-help">
        {" "}
        contact our support team{" "}
      </Link>
      for help.
    </>
  ),
  fallback:
    "The payment was not processed due to a problem with the account. Try a different payment method or contact your bank or card issuer for help.",
};

export const OverdueInvoiceAlert = ({ failureReason }: Props) => (
  <Alert type="error">
    <AlertDescription>{messages[failureReason ?? "fallback"]}</AlertDescription>
  </Alert>
);
